<div class="modal-content">
  <div class="modal-body text-center modal-aviso-acesso-camera__body">
    <div class="modal-aviso-acesso-camera__title">Acesso à sua câmera</div>
    <div class="modal-aviso-acesso-camera__subtitle">Como vamos <strong>tirar uma foto sua</strong>, precisamos que você <strong>nos permita o acesso à sua câmera.</strong></div>
    <div class="modal-aviso-acesso-camera__subtitle">Clique em “<strong>Permitir</strong>” no pop-up que aparecerá na próxima tela</div>
    <section class="modal-aviso-acesso-camera__content">
      <img src="../../../../../assets/images/verify_warn_videocam.svg" alt="videocam">
    </section>
  </div>
  <div class="modal-footer modal-aviso-acesso-camera__action">
    <app-gradient-button
      label="OK, ENTENDI"
      (click)="close()">
    </app-gradient-button>
  </div>
</div>
